export const sr = {
  // Common
  common: {
    save: 'Sačuvaj',
    cancel: 'Otkaži',
    delete: 'Obriši',
    edit: 'Izmeni',
    add: 'Dodaj',
    search: 'Pretraži',
    searchGroups: 'Pretraži grupe...',
    searchVehicles: 'Pretraži vozila...',
    noGroupsFound: 'Nema pronađenih grupa',
    noVehiclesFound: 'Nema pronađenih vozila',
    searchDrivers: 'Pretraži vozače...',
    noDriversFound: 'Nema pronađenih vozača',
    loading: 'Učitavanje...',
    noData: 'Nema podataka',
    today: 'Danas',
    yesterday: 'Juče',
    thisWeek: 'Ova nedelja',
    last7Days: 'Poslednjih 7 dana',
    last30Days: 'Poslednjih 30 dana',
    thisMonth: 'Ovaj mesec',
    customRange: 'Prilagođeni period',
    backToPresets: 'Nazad na periode',
    all: 'Sve',
    showing: 'Prikazano',
    to: 'do',
    of: 'od',
    entries: 'unosa',
    page: 'Stranica',
    rows: 'redova',
    refresh: 'Osveži',
    selectAll: 'Izaberi sve',
    selectRow: 'Izaberi red',
    pageNotFound: 'Ups! Stranica nije pronađena',
    returnToHome: 'Nazad na početnu',
    kilometersShort: 'km',
    kilometersPerHourShort: 'km/h',
    litersShort: 'L',
    litersPer100KmShort: 'L/100km',
    exportFailed: 'Izvoz nije uspeo',
    exportPdf: 'Izvezi PDF',
    exportExcel: 'Izvezi Excel',
    pdfExported: 'PDF izvezen',
    excelExported: 'Excel izvezen',
    exportSuccess: 'je uspešno preuzet.',
    dateRangeLabel: 'Opseg datuma',
    generatedLabel: 'Generisano',
    exportedBy: 'Izvezao',
    totalsLabel: 'Ukupno',
    records: 'zapisa',
    total: 'Ukupno',
    hoursShort: 'h',
    minutesShort: 'm',
    secondsShort: 's',
    percentSymbol: '%',
    previous: 'Prethodno',
    next: 'Sledeće',
    more: 'Više',
    morePages: 'Još stranica',
    close: 'Zatvori',
    toggleSidebar: 'Prikaži/sakrij meni',
    previousSlide: 'Prethodni slajd',
    nextSlide: 'Sledeći slajd',
    pagination: 'Paginacija',
    breadcrumb: 'Putanja',
  },

  // Navigation
  nav: {
    liveTracking: 'Praćenje uživo',
    history: 'Istorija',
    vehicles: 'Vozila',
    drivers: 'Vozači',
    zones: 'Zone',
    poi: 'Tačke interesa',
    reports: 'Izveštaji',
    notifications: 'Obaveštenja',
    costs: 'Troškovi',
    editProfile: 'Podešavanje naloga',
    editProfileDesc: 'Izmenite ime, kontakt podatke i lozinku',
    profileUpdated: 'Profil je ažuriran',
    userSettings: 'Podešavanja korisnika',
    systemSettings: 'Sistemska podešavanja',
    signOut: 'Odjava',
    plan: 'Paket',
    userGuide: 'Korisnički vodič (PDF)',
    language: 'Jezik',
    settings: 'Podešavanja',
    groups: 'Grupe',
    users: 'Korisnici',
    activity: 'Dnevnik aktivnosti',
    scheduledReports: 'Zakazani izveštaji',
  },

  // Auth
  auth: {
    welcomeBack: 'Dobrodošli nazad',
    signInToContinue: 'Prijavite se na svoj nalog da nastavite',
    username: 'Korisničko ime',
    email: 'Email',
    password: 'Lozinka',
    signIn: 'Prijava',
    signingIn: 'Prijavljivanje...',
    fleetManagementSystem: 'Sistem za upravljanje flotom',
    demoCredentials: 'Demo: Koristite bilo koji email i lozinku (min 6 karaktera)',
    invalidCredentials: 'Pogrešni podaci za prijavu',
    enterCredentials: 'Molimo unesite vaše podatke',
    passwordMinLength: 'Lozinka mora imati najmanje 6 karaktera',
    sessionExpired: 'Vaša sesija je istekla. Prijavite se ponovo.',
    appName: 'Global GPS',
    usernamePlaceholder: 'korisnicko ime',
    passwordPlaceholder: '••••••••',
    realTimeGpsTracking: 'GPS praćenje u realnom vremenu',
    monitorFleet247: 'Pratite vašu flotu 24/7',
    routeHistory: 'Istorija ruta',
    detailedVehicleData: 'Detaljni podaci o vozilu za svaku vožnju',
    enterpriseSecurity: 'Bezbednost za preduzeća',
    encryptedDataRoleBasedAccess: 'Šifrovani podaci i pristup po ulogama',
    pro: 'Pro',
    basic: 'Basic',
  },

  apiErrors: {
    invalid_preferences: 'Podešavanja obaveštenja nije moguće sačuvati',
    missing_credentials: 'Korisničko ime i lozinka su obavezni',
    invalid_credentials: 'Pogrešno korisničko ime ili lozinka',
    missing_api_key: 'Prijavite se da biste nastavili',
    invalid_token: 'Vaša sesija je istekla. Prijavite se ponovo.',
    invalid_user: 'Korisnički nalog nije pronađen',
    group_in_use: 'Grupa se ne može obrisati dok su korisnici ili vozila dodeljeni',
    username_exists: 'Korisničko ime već postoji',
    cannot_delete_self: 'Ne možete obrisati sopstveni nalog',
    not_found: 'Traženi resurs nije pronađen',
    forbidden: 'Nemate dozvolu za ovu akciju',
    missing_fields: 'Popunite sva obavezna polja',
    missing_id: 'Nedostaje ID resursa',
    method_not_allowed: 'Akcija nije dozvoljena',
    invalid_group: 'Izabrana grupa nije validna',
    invalid_device: 'To vozilo vam nije dostupno',
    invalid_category: 'Ta kategorija nije dostupna',
    invalid_currency: 'Valuta nije podržana',
    category_in_use: 'Kategorija se koristi ili taj kod već postoji',
    recurrence_in_use: 'Ovo pravilo je već generisalo troškove i ne može se obrisati',
    cost_exists: 'Ovaj trošak već postoji. Vraćen je ranije.',
    cost_locked: 'Ovaj trošak je zaključen. Samo administrator ga može otključati.',
    invalid_rule: 'Pravilo ponavljanja je nepotpuno ili neispravno',
    readonly_field: 'Polje samo za čitanje se ne može menjati',
    server_error: 'Server nije mogao da sačuva izmenu. Ništa nije sačuvano.',
    request_failed: 'Zahtev nije uspeo. Pokušajte ponovo.',
    invalid_request: 'Neispravan format zahteva',
    invalid_response: 'Neočekivan odgovor servera',
    range_too_long: 'Period može biti najviše 31 dan.',
    invalid_file: 'Tip ili veličina fajla nisu dozvoljeni',
    too_many_files: 'Ovaj trošak već ima najviše 10 fajlova',
    upload_missing: 'Otpremanje nije završeno. Pokušajte ponovo.',
    s3_EntityTooLarge: 'Fajl je veći od 20 MB',
    s3_AccessDenied: 'Link za otpremanje je istekao. Pokušajte ponovo.',
    invalid_schedule: 'Raspored je nepotpun ili neispravan',
    invalid_recipients: 'Jedna ili više email adresa nisu ispravne',
    too_many_recipients: 'Raspored može imati najviše 10 primalaca',
    invalid_timezone: 'Nepoznata vremenska zona',
    schedule_limit: 'Dostigli ste maksimum od 20 zakazanih izveštaja',
    too_many_requests: 'Sačekajte minut pre ponovnog slanja',
  },

  // Live Tracking
  tracking: {
    vehicles: 'Vozila',
    searchVehicles: 'Pretraži vozila...',
    visible: 'Vidljivo',
    moving: 'U pokretu',
    idle: 'Miruje',
    stopped: 'Zaustavljeno',
    offline: 'Van mreže',
    following: 'Praćenje',
    speed: 'Brzina',
    altitude: 'Visina',
    satellites: 'Sateliti',
    fuelLevel: 'Nivo goriva',
    fuelUsed: 'Potrošeno goriva',
    distance: 'Rastojanje',
    engineTemp: 'Temp. motora',
    rpm: 'Obrtaji',
    heading: 'Smer',
    fuel: 'Gorivo',
    ignition: 'Paljenje',
    on: 'Uključeno',
    off: 'Isključeno',
    sensors: 'Senzori',
    history: 'Istorija',
    settings: 'Podešavanja',
    trackVehicle: 'Prati ovo vozilo',
    stopTracking: 'Zaustavi praćenje',
    hideDetails: 'Sakrij detalje',
    showDetails: 'Prikaži detalje',
    noCoordinates: 'Nema koordinata (skriveno na mapi)',
    withoutCoordinates: 'Bez koordinata',
    isolateStatusHint: 'Dvoklik prikazuje samo ovaj status',
    overview: 'Pregled',
    general: 'Opšte',
    sentData: 'Poslati podaci',
    reports: 'Izveštaji',
    lastUpdate: 'Poslednje ažuriranje',
    lastUpdateUnderMinute: '<1 min',
    lastUpdateMinutesUnit: 'min',
    latestInputs: 'Najnoviji ulazi',
    noSensorData: 'Nema podataka sa senzora',
    openReportsForVehicle: 'Otvori izveštaje filtrirane za ovo vozilo.',
    openReports: 'Otvori izveštaje',
    followingGroup: 'Praćenje grupe',
    make: 'Marka',
    model: 'Model',
    year: 'Godina',
    registration: 'Registracija',
    deviceId: 'ID uređaja',
    noData: 'Nema podataka',
    viewHistory: 'Pogledaj istoriju vozila',
    driver: 'Vozač',
    goToHistory: 'Idi na istoriju',
    vehicleTable: 'Tabela vozila',
    vehicleTableDesc: 'Sva vozila sa najnovijom telemetrijom, grupisana po grupi vozila.',
  },

  // Map
  map: {
    street: 'Ulična',
    muted: 'Prigušena',
    satellite: 'Satelitska',
    dark: 'Tamna',
    terrain: 'Teren',
  },

  // History
  historyPage: {
    title: 'Istorija i izveštaji',
    subtitle: 'Pregled istorije putovanja, ruta i događaja',
    group: 'Grupa',
    allGroups: 'Sve grupe',
    vehicle: 'Vozilo',
    allVehicles: 'Sva vozila',
    period: 'Period',
    startTime: 'Vreme početka',
    endTime: 'Vreme završetka',
    invalidDateRange: 'Datum i vreme završetka moraju biti nakon datuma i vremena početka.',
    loadHistory: 'Učitaj istoriju',
    filtersChanged: 'Filteri su promenjeni. Kliknite “Učitaj istoriju” da osvežite.',
    loadHistoryPrompt: 'Podesite filtere i kliknite “Učitaj istoriju” da prikažete putovanja.',
    trips: 'Putovanja',
    distance: 'Rastojanje',
    distanceTotal: 'Ukupno rastojanje',
    fuelTotal: 'Ukupno gorivo',
    avgSpeed: 'Prosečna brzina',
    events: 'Događaji',
    distanceByDay: 'Rastojanje po danu',
    eventsByType: 'Događaji po tipu',
    noEvents: 'Nema događaja u izabranom periodu',
    /** Keyed by the upstream `has_<type>` suffix; unknown types fall back to a humanized label. */
    routeEvents: {
      speeding: 'Prekoračenje brzine vozila',
      street_speeding: 'Prekoračenje ograničenja',
      fuel_drain: 'Istakanje goriva',
      refuel: 'Točenje goriva',
      parking_zone_changed: 'Promena parking zone',
      go_zone_changed: 'Promena zone vožnje',
      nogo_zone_changed: 'Promena zabranjene zone',
    },
    start: 'Početak',
    end: 'Kraj',
    duration: 'Trajanje',
    viewRoute: 'Prikaži rutu',
    route: 'Ruta',
    maxSpeed: 'Maks. brzina',
    speedViolation: 'Prekoračenje brzine',
    harshBrake: 'Naglo kočenje',
    harshAcceleration: 'Naglo ubrzanje',
    idle: 'Mirovanje',
    fuel: 'Gorivo',
    fuelConsumed: 'Utrošeno gorivo',
    avgConsumption: 'Prosečna potrošnja',
    geofence: 'Geofence',
    routeStop: 'Zaustavljanje',
    groupBy: 'Grupisanje',
    groupByNone: 'Bez grupisanja',
    groupByDateVehicle: 'Datum → Vozilo',
    groupByVehicleDate: 'Vozilo → Datum',
    continued: 'nastavak',
    tooManyRoutes: 'ruta učitano — prikaz može biti spor. Suzite vremenski period ili izaberite manje vozila.',
    statsToggle: 'Statistika',
    showChart: 'Prikaži grafikon',
    hideChart: 'Sakrij grafikon',
    exportMapPdf: 'Izvezi mapu (PDF)',
    mapExportTitle: 'Mapa rute',
    pointReadout: 'Vrednosti u označenoj tački',
    pointTime: 'Vreme',
  },

  // Vehicles
  vehiclesPage: {
    title: 'Vozila',
    subtitle: 'Upravljanje vozilima i podešavanjima flote',
    addVehicle: 'Dodaj vozilo',
    addNewVehicle: 'Dodaj novo vozilo',
    addNewVehicleDesc: 'Dodajte novo vozilo u vašu flotu',
    vehicleName: 'Naziv vozila',
    plateNumber: 'Registracija',
    deviceId: 'ID',
    selectGroup: 'Izaberite grupu',
    selectDriver: 'Izaberite vozača',
    noDriver: 'Bez vozača',
    driverAlreadyAssignedTitle: 'Vozač je već dodeljen',
    driverAlreadyAssignedDesc: 'Ovaj vozač je već dodeljen vozilima ispod. Nastavak zadržava te dodele i dodaje ovu.',
    driverName: 'Ime vozača',
    totalVehicles: 'Ukupno vozila',
    vehicleGroups: 'Grupe vozila',
    allVehicles: 'Sva vozila',
    odometer: 'Kilometraža',
    tankCapacity: 'Kapacitet rezervoara (L)',
    make: 'Marka',
    model: 'Model',
    year: 'Godište',
    vehicleUpdated: 'Vozilo je ažurirano',
    maxSpeed: 'Maksimalna brzina',
    trackSpeeding: 'Prati maks. brzinu vozila',
    trackStreetSpeeding: 'Prati ograničenje na ulici',
    speedControl: 'Kontrola brzine',
    editSelected: 'Izmeni izabrana',
    selectedCount: '{count} izabrano',
    bulkEditTitle: 'Izmena izabranih vozila',
    bulkEditDesc: 'Samo polja koja omogućite ispod biće promenjena na izabranim vozilima.',
    changeField: 'Promeni ovo polje',
    clearSelection: 'Poništi izbor',
    bulkUpdated: '{count} vozila ažurirano',
    bulkUpdatedPartial: '{updated} ažurirano, {failed} neuspešno',
    allGroups: 'Sve grupe',
    addService: 'Dodaj servis',
    vehicleSettings: 'Podešavanje',
    vehicleActions: 'Akcije vozila',
  },

  // Drivers
  driversPage: {
    title: 'Vozači',
    subtitle: 'Upravljanje vozačima i dodelama vozila',
    addDriver: 'Dodaj vozača',
    addNewDriver: 'Dodaj novog vozača',
    addNewDriverDesc: 'Dodajte novog vozača u vašu flotu',
    editDriver: 'Izmeni vozača',
    editDriverDesc: 'Ažurirajte informacije o vozaču',
    fullName: 'Ime i prezime',
    phone: 'Telefon',
    rfid: 'RFID',
    license: 'Dozvola',
    licenseNumber: 'Broj dozvole',
    licenseExpiry: 'Datum isteka dozvole',
    address: 'Adresa',
    city: 'Grad',
    zip: 'Poštanski broj',
    expires: 'Ističe',
    assignedVehicle: 'Dodeljeno vozilo',
    assignVehicle: 'Dodeli vozilo',
    selectVehicle: 'Izaberi vozilo',
    status: 'Status',
    active: 'Aktivan',
    inactive: 'Neaktivan',
    onLeave: 'Na odsustvu',
    unassigned: 'Nedodeljen',
    totalDrivers: 'Ukupno vozača',
    assigned: 'Dodeljeno',
    allDrivers: 'Svi vozači',
    saveChanges: 'Sačuvaj izmene',
    driverAdded: 'Vozač uspešno dodat',
    driverUpdated: 'Vozač uspešno ažuriran',
    driverDeleted: 'Vozač uspešno obrisan',
    assignedVehicles: 'Dodeljena vozila',
    assignmentUpdated: 'Dodela vozila ažurirana',
    firstNamePlaceholder: 'Marko',
    lastNamePlaceholder: 'Marković',
  },

  // Zones
  zonesPage: {
    title: 'Zone',
    subtitle: 'Upravljanje geofence zonama za vašu flotu',
    drawZone: 'Nacrtaj zonu',
    undoPoint: 'Poništi tačku',
    points: 'tačaka',
    totalZones: 'Ukupno zona',
    parking: 'Parking',
    noGo: 'Zabranjena',
    driving: 'Vožnja',
    custom: 'Prilagođena',
    parkingZone: 'Parking zona',
    noGoZone: 'Zabranjena zona',
    drivingZone: 'Zona vožnje',
    customZone: 'Prilagođena zona',
    zoneMap: 'Mapa zona',
    zoneList: 'Lista zona',
    createZone: 'Kreiraj zonu',
    createZoneDesc: 'Imenujte i konfigurišite vašu novu zonu',
    editZone: 'Izmeni zonu',
    editZoneDesc: 'Ažurirajte podešavanja zone',
    zoneName: 'Naziv zone',
    zoneType: 'Tip zone',
    clickToAdd: 'Kliknite na mapu da dodate tačke',
    noZones: 'Nema kreiranih zona. Kliknite "Nacrtaj zonu" da kreirate.',
    zoneCreated: 'Zona uspešno kreirana',
    zoneUpdated: 'Zona uspešno ažurirana',
    zoneDeleted: 'Zona uspešno obrisana',
    needMorePoints: 'Zona zahteva najmanje 3 tačke',
    zoneNamePlaceholder: 'npr. Glavni parking',
    shape: 'Oblik',
    clearPoints: 'Obriši tačke',
    pointLabel: 'Tačka',
    noPointsYet: 'Kliknite na mapu da postavite prvu tačku obrisa zone.',
    drawInstructions: 'Nastavite da klikćete na mapu da dodate tačke. Koristite Poništi ili Obriši za ispravku.',
    zoneDescription: 'Opis',
    zoneDescriptionPlaceholder: 'Opcione napomene o zoni',
  },

  // POI
  poiPage: {
    title: 'Tačke interesa',
    subtitle: 'Upravljanje lokacijama i kontaktima',
    addPoi: 'Dodaj POI',
    addPoiTitle: 'Dodaj tačku interesa',
    addPoiDesc: 'Dodajte novu lokaciju na vašu mapu',
    editPoiTitle: 'Izmeni tačku interesa',
    editPoiDesc: 'Ažurirajte informacije o POI',
    total: 'Ukupno',
    partner: 'Partner',
    gasStation: 'Benzinska pumpa',
    warehouse: 'Magacin',
    customer: 'Kupac',
    serviceCenter: 'Servisni centar',
    other: 'Ostalo',
    poiMap: 'POI mapa',
    poiList: 'POI lista',
    name: 'Naziv',
    type: 'Tip',
    address: 'Adresa',
    latitude: 'Geografska širina',
    longitude: 'Geografska dužina',
    clickToSelect: 'Kliknite na mapu da izaberete lokaciju',
    contactPerson: 'Kontakt osoba',
    contactPhone: 'Kontakt telefon',
    contactEmail: 'Kontakt email',
    description: 'Opis',
    descriptionPlaceholder: 'Opcioni opis ove lokacije',
    notes: 'Napomene',
    additionalNotes: 'Dodatne napomene...',
    noPois: 'Nema kreiranih POI. Kliknite "Dodaj POI" da kreirate.',
    poiAdded: 'POI uspešno dodat',
    poiUpdated: 'POI uspešno ažuriran',
    poiDeleted: 'POI uspešno obrisan',
    namePlaceholder: 'npr. Glavna kancelarija',
    addressPlaceholder: 'Glavna 123, Grad',
    contactPersonPlaceholder: 'Petar Petrović',
    contactPhonePlaceholder: '+381 60 123 4567',
    contactEmailPlaceholder: 'kontakt@firma.rs',
    location: 'Lokacija',
    dragMarkerHint: 'Prevucite marker ili kliknite na mapu da ga pomerite.',
  },

  // Reports
  reportsPage: {
    title: 'Izveštaji',
    subtitle: 'Generišite i izvezite prilagođene izveštaje flote',
    generateReport: 'Generiši izveštaj',
    filtersChanged: 'Filteri su promenjeni. Kliknite “Generiši izveštaj” da osvežite.',
    reportType: 'Tip izveštaja',
    tripReport: 'Izveštaj o putovanjima',
    fuelReport: 'Izveštaj o gorivu',
    driverReport: 'Izveštaj o vozačima',
    vehicleUtilization: 'Iskorišćenost vozila',
    dateRange: 'Opseg datuma',
    pickDateRange: 'Izaberite opseg datuma',
    invalidDateRange: 'Datum i vreme završetka moraju biti nakon datuma i vremena početka.',
    tripReportDesc: 'Redovi putovanja iz API istorije ruta: tablice vozila, segmenti, rastojanja, brzine, uzorak tačaka',
    fuelReportDesc: 'Točenja goriva po vozilu: koliko puta, koliko ukupno i kada je poslednje',
    driverReportDesc: 'Zbir po vozaču iz istorije ruta (rastojanje, vreme, brzine) i vožena vozila',
    vehicleReportDesc: 'Zbir po vozilu iz istorije ruta (rastojanje, vreme, brzine) i dodeljena grupa',
    startTime: 'Vreme početka',
    endTime: 'Vreme završetka',
    refuelCount: 'Broj točenja',
    refuelledTotalL: 'Ukupno natočeno (L)',
    lastRefuel: 'Poslednje točenje',
    drainCount: 'Broj istakanja',
    startLocation: 'Početna lokacija',
    endLocation: 'Krajnja lokacija',
    distanceKm: 'Rastojanje (km)',
    durationMin: 'Trajanje (min)',
    avgSpeedKmh: 'Prosečna brzina (km/h)',
    fuelL: 'Utrošeno gorivo (L)',
    avgConsumption: 'Prosečna potrošnja',
    routeNo: 'Ruta br.',
    pointsCount: 'Tačaka (uzorka)',
    totalDurationMinutes: 'Ukupno trajanje (min)',
    totalDurationHms: 'Ukupno trajanje (hh:mm:ss)',
    dateTime: 'Datum/Vreme',
    location: 'Lokacija',
    odometerKm: 'Kilometraža (km)',
    driver: 'Vozač',
    totalTrips: 'Ukupno putovanja',
    totalDistanceKm: 'Ukupno rastojanje (km)',
    group: 'Grupa',
    fuelLevelPercent: 'Nivo goriva (%)',
    showingFirst: 'Prikazano prvih',
    ofRecords: 'zapisa. Izvezite da vidite sve podatke.',
    allTime: 'Ceo period',
    refuel: 'Točenje',
    consumption: 'Potrošnja',
    theft: 'Krađa',
  },

  // Notifications
  notificationsPage: {
    settings: 'Podešavanja obaveštenja',
    title: 'Obaveštenja',
    unreadNotifications: 'nepročitanih obaveštenja',
    allCaughtUp: 'Sve ste pročitali!',
    markAllRead: 'Označi sve kao pročitano',
    total: 'Ukupno',
    alerts: 'Uzbune',
    warnings: 'Upozorenja',
    unread: 'Nepročitano',
    noNotifications: 'Nema obaveštenja',
    youreAllCaughtUp: 'Sve ste pročitali!',
    eventLocation: 'Mesto događaja',
    locationUnavailable: 'Za ovu notifikaciju nije zabeležena lokacija.',
    view: 'Pogledaj',
    followLive: 'Prati vozilo uživo',
  },

  // Live vehicle events (docs/Events.MD) and their toast preferences
  vehicleEvents: {
    types: {
      parking_enter: 'Vozilo je ušlo u parking zonu',
      parking_exit: 'Vozilo je napustilo parking zonu',
      go_zone_enter: 'Vozilo je ušlo u dozvoljenu zonu',
      go_zone_exit: 'Vozilo je napustilo dozvoljenu zonu',
      nogo_zone_enter: 'Vozilo je ušlo u zabranjenu zonu',
      nogo_zone_exit: 'Vozilo je napustilo zabranjenu zonu',
      driver_identified: 'Vozač identifikovan',
      driver_removed: 'Vozač uklonjen',
      driver_changed: 'Vozač promenjen',
      started: 'Motor upaljen',
      stopped: 'Motor ugašen',
      speeding_start: 'Vozilo je prekoračilo brzinu (ograničenje vozila)',
      speeding_end: 'Vozilo je ponovo ispod ograničenja vozila',
      street_speeding_start: 'Vozilo je prekoračilo ograničenje na putu',
      street_speeding_end: 'Vozilo je ponovo ispod ograničenja na putu',
      refuel: 'Točenje goriva',
      missing_fuel: 'Pad nivoa goriva',
      overheat: 'Pregrevanje motora',
    },
    categories: {
      zone: 'Zone',
      driver: 'Vozač',
      engine: 'Motor',
      speed: 'Brzina',
      fuel: 'Gorivo',
    },
    prefsTitle: 'Iskačuća obaveštenja',
    prefsHint: 'Izaberite koji događaji vozila iskaču. Događaji koji iskoče čuvaju se i u listi obaveštenja.',
    savedInstantly: 'Izmene se čuvaju čim promenite prekidač.',
    toggleAll: 'Sve',
    muteSound: 'Isključi zvuk',
    unmuteSound: 'Uključi zvuk',
    newNotifications: 'novih obaveštenja',
    view: 'Pogledaj',
    vehicle: 'Vozilo',
    zone: 'Zona',
    limit: 'ograničenje',
  },

  // User Settings
  usersPage: {
    title: 'Korisnici',
    subtitle: 'Upravljanje korisnicima klijenta i dodeljenim grupama',
    addUser: 'Dodaj korisnika',
    editUser: 'Izmeni korisnika',
    addUserDesc: 'Kreirajte novi korisnički nalog',
    editUserDesc: 'Ažurirajte podatke korisnika i pristup grupama',
    fullName: 'Ime i prezime',
    username: 'Korisničko ime',
    password: 'Lozinka',
    passwordOptional: 'Lozinka (ostavite prazno da ostane trenutna)',
    email: 'Email',
    phone: 'Telefon',
    groups: 'Grupe',
    noGroups: 'Nema dostupnih grupa',
    selectedGroups: 'Izabrane grupe',
    totalUsers: 'Ukupno korisnika',
    allUsers: 'Svi korisnici',
    userAdded: 'Korisnik je uspešno kreiran',
    userUpdated: 'Korisnik je uspešno ažuriran',
    userDeleted: 'Korisnik je uspešno obrisan',
    assignedGroups: 'Dodeljene grupe',
    noAssignedGroups: 'Nema dodeljenih grupa',
    fullNamePlaceholder: 'Petar Petrović',
    usernamePlaceholder: 'petar.petrovic',
    emailPlaceholder: 'petar@firma.rs',
    phonePlaceholder: '+381 60 123 4567',
  },

  // User Settings
  userSettingsPage: {
    title: 'Podešavanja korisnika',
    subtitle: 'Upravljajte vašim nalogom i preferencama',
    profile: 'Profil',
    profileDesc: 'Vaši lični podaci',
    fullName: 'Ime i prezime',
    email: 'Email',
    phone: 'Telefon',
    role: 'Uloga',
    saveChanges: 'Sačuvaj izmene',
    notifications: 'Obaveštenja',
    notificationsDesc: 'Konfigurišite kako primate obaveštenja',
    emailNotifications: 'Email obaveštenja',
    emailNotificationsDesc: 'Primajte obaveštenja putem emaila',
    pushNotifications: 'Push obaveštenja',
    pushNotificationsDesc: 'Primajte push obaveštenja u pretraživaču',
    alertTypes: 'Tipovi upozorenja',
    speedViolations: 'Prekoračenje brzine',
    fuelAlerts: 'Upozorenja o gorivu',
    geofenceAlerts: 'Geofence upozorenja',
    maintenanceReminders: 'Podsetnici za održavanje',
    preferences: 'Preference',
    preferencesDesc: 'Prilagodite vaše iskustvo',
    language: 'Jezik',
    defaultCurrency: 'Zadana valuta',
    defaultCurrencyDesc: 'Novi troškovi i ponavljajući troškovi počinju u ovoj valuti. Na svakom trošku je i dalje možete promeniti.',
    defaultCurrencySaved: 'Zadana valuta je sačuvana',
    defaultCurrencyUnavailable: 'Čuvanje zadane valute još nije dostupno.',
    timezone: 'Vremenska zona',
    distanceUnit: 'Jedinica rastojanja',
    kilometers: 'Kilometri',
    miles: 'Milje',
    dateFormat: 'Format datuma',
    savePreferences: 'Sačuvaj preference',
    security: 'Bezbednost',
    securityDesc: 'Upravljajte bezbednošću vašeg naloga',
    currentPassword: 'Trenutna lozinka',
    newPassword: 'Nova lozinka',
    confirmPassword: 'Potvrdi lozinku',
    updatePassword: 'Ažuriraj lozinku',
    settingsSaved: 'Podešavanja uspešno sačuvana',
    phonePlaceholder: '+381 60 123 4567',
    pacificTime: 'Pacifičko vreme (UTC-8)',
    easternTime: 'Istočno vreme (UTC-5)',
    centralEuropeanTime: 'Centralnoevropsko vreme (UTC+1)',
    dateFormatMdy: 'MM/DD/GGGG',
    dateFormatDmy: 'DD/MM/GGGG',
    dateFormatYmd: 'GGGG-MM-DD',
    utc: 'UTC',
  },

  // System Settings
  systemSettingsPage: {
    title: 'Sistemska podešavanja',
    subtitle: 'Konfigurišite globalne sistemske preference',
    mapSettings: 'Podešavanja mape',
    mapSettingsDesc: 'Konfigurišite prikaz i ponašanje mape',
    refreshInterval: 'Interval osvežavanja (sekunde)',
    showTrafficLayer: 'Prikaži sloj saobraćaja',
    showTrafficDesc: 'Prikaz podataka o saobraćaju u realnom vremenu',
    satelliteView: 'Satelitski prikaz',
    satelliteViewDesc: 'Koristi satelitske snimke',
    clusterMarkers: 'Grupiši markere',
    clusterMarkersDesc: 'Grupiši bliska vozila kada se umanji prikaz',
    alertThresholds: 'Pragovi upozorenja',
    alertThresholdsDesc: 'Postavite pragove za automatska upozorenja',
    speedLimitKmh: 'Ograničenje brzine (km/h)',
    idleTimeoutMin: 'Timeout mirovanja (minuti)',
    lowFuelThreshold: 'Prag niskog nivoa goriva (%)',
    geofenceAlerts: 'Geofence upozorenja',
    geofenceAlertsDesc: 'Upozori kada vozila napuste određene zone',
    saveAlertSettings: 'Sačuvaj podešavanja upozorenja',
    notificationDelivery: 'Dostava obaveštenja',
    notificationDeliveryDesc: 'Konfigurišite kako se obaveštenja šalju korisnicima',
    emailServer: 'Email server (SMTP)',
    smtpPort: 'SMTP port',
    fromEmail: 'Email pošiljaoca',
    replyToEmail: 'Reply-to email',
    saveNotificationSettings: 'Sačuvaj podešavanja obaveštenja',
    dataRetention: 'Čuvanje podataka',
    dataRetentionDesc: 'Konfigurišite politike čuvanja i čišćenja podataka',
    gpsHistoryRetention: 'Čuvanje GPS istorije',
    tripHistoryRetention: 'Čuvanje istorije putovanja',
    alertHistoryRetention: 'Čuvanje istorije upozorenja',
    backupFrequency: 'Učestalost rezervnih kopija',
    days: 'dana',
    year: '1 godina',
    years: '2 godine',
    hourly: 'Svakog sata',
    daily: 'Dnevno',
    weekly: 'Nedeljno',
    saveRetentionSettings: 'Sačuvaj podešavanja čuvanja',
    apiIntegrations: 'API i integracije',
    apiIntegrationsDesc: 'Upravljajte API ključevima i integracijama sa trećim stranama',
    apiKey: 'API ključ',
    regenerate: 'Regeneriši',
    apiKeyDesc: 'Koristite ovaj ključ za integraciju sa eksternim sistemima',
    webhookUrl: 'Webhook URL',
    webhookDesc: 'Događaji će biti poslati na ovaj URL u realnom vremenu',
    saveApiSettings: 'Sačuvaj API podešavanja',
    systemSettingsSaved: 'Sistemska podešavanja uspešno sačuvana',
    emailServerPlaceholder: 'smtp.firma.rs',
    smtpPortPlaceholder: '587',
    fromEmailPlaceholder: 'obavestenja@firma.rs',
    replyToEmailPlaceholder: 'podrska@firma.rs',
    webhookUrlPlaceholder: 'https://api.vasafirma.com/webhooks/fleet',
  },

  // Groups
  groupsPage: {
    title: 'Grupe vozila',
    subtitle: 'Organizujte vašu flotu u logičke grupe',
    addGroup: 'Dodaj grupu',
    addNewGroup: 'Dodaj novu grupu',
    addNewGroupDesc: 'Kreirajte novu grupu vozila za vašu flotu',
    groupName: 'Naziv grupe',
    groupNamePlaceholder: 'Unesite naziv grupe...',
    groupColor: 'Boja grupe',
    totalGroups: 'Ukupno grupa',
    avgVehiclesPerGroup: 'Prosečno po grupi',
    allGroups: 'Sve grupe',
    allGroupsDesc: 'Upravljajte vašim grupama vozila i njihovim podešavanjima',
    vehiclesAssigned: 'dodeljenih vozila',
    editGroup: 'Izmeni grupu',
    editGroupDesc: 'Ažurirajte naziv i boju grupe',
    groupAdded: 'Grupa dodata',
    groupAddedDesc: 'Grupa vozila je uspešno kreirana.',
    groupUpdated: 'Grupa ažurirana',
    groupUpdatedDesc: 'Grupa vozila je uspešno ažurirana.',
    groupDeleted: 'Grupa obrisana',
    groupDeletedDesc: 'Grupa vozila je obrisana.',
    cannotDelete: 'Nije moguće obrisati grupu',
    groupHasVehicles: 'Ova grupa još uvek ima dodeljena vozila.',
  },

  // Costs
  costsPage: {
    title: 'Troškovi',
    subtitle: 'Troškovi vozila, ponavljajući rasporedi i nadolazeći podsetnici',
    tabOverview: 'Pregled',
    tabCosts: 'Troškovi',
    tabRecurrences: 'Ponavljanja',
    tabUpcoming: 'Nadolazeće',
    tabDeleted: 'Obrisani',
    addCost: 'Dodaj trošak',
    addCostDesc: 'Evidentiraj novi trošak za vozilo',
    editCost: 'Izmeni trošak',
    editCostDesc: 'Ažuriraj zapis o trošku',
    saveChanges: 'Sačuvaj izmene',
    vehicle: 'Vozilo',
    category: 'Kategorija',
    date: 'Datum',
    amount: 'Iznos',
    currency: 'Valuta',
    chartsCurrencyNote: 'Grafikoni prikazuju samo troškove u {currency}.',
    costTitle: 'Naziv',
    description: 'Opis',
    odometer: 'Kilometraža',
    planned: 'Planiran',
    unplanned: 'Neplaniran',
    status: 'Status',
    vendor: 'Dobavljač',
    invoiceNo: 'Broj računa',
    documentUrl: 'Link ka dokumentu',
    statusPlanned: 'Planiran',
    statusDone: 'Realizovan',
    statusCancelled: 'Otkazan',
    statusInProgress: 'U toku',
    selectVehicle: 'Izaberi vozilo',
    selectCategory: 'Izaberi kategoriju',
    searchCategories: 'Pretraži kategorije...',
    noCategoriesFound: 'Nema pronađenih kategorija',
    allCategories: 'Sve kategorije',
    allStatuses: 'Svi statusi',
    allVehicles: 'Sva vozila',
    useCurrentOdometer: 'Koristi trenutno stanje',
    totalCost: 'Potrošeno',
    plannedTotal: 'Planirano',
    unplannedTotal: 'Neplanirano',
    costCount: 'Zapisa',
    forecastTotal: 'Prognoza',
    markDone: 'Označi kao realizovano',
    completeCost: 'Potvrdi trošak',
    completeCostDesc: 'Unesite stvarni datum, kilometražu i iznos. Sledeće dospeće se računa od njih.',
    costCompleted: 'Trošak označen kao realizovan',
    anchorHint: 'Kada je ovo poslednji put urađeno. Sledeće dospeće i kilometraža se računaju od toga.',
    recurrenceInUse: 'Ovo pravilo je već generisalo troškove, pa se ne može obrisati. Deaktivirajte ga da biste zaustavili podsetnike.',
    deactivate: 'Deaktiviraj',
    recurrenceDeactivated: 'Pravilo deaktivirano',
    recurrenceHistoryDesc: 'Ko je kreirao i menjao ovo pravilo, i troškovi koje je generisalo',
    readOnlyNotice: 'Možete pregledati troškove, ali ne i menjati ih',
    startCost: 'Započni trošak',
    startCostDesc: 'Otvorite trošak samo sa vozilom. Dopunjavajte opis kako posao napreduje, a na kraju unesite cenu i zaključite ga.',
    closeCost: 'Zaključi trošak',
    closeCostDesc: 'Unesite konačan iznos, datum i kilometražu. Nakon zaključivanja samo administrator može otključati trošak.',
    closeConfirmTitle: 'Zaključiti trošak?',
    closeConfirm: 'Nakon zaključivanja trošak je zaključan i samo administrator ga može otključati.',
    costClosed: 'Trošak zaključen',
    unlockCost: 'Otključaj',
    unlockConfirmTitle: 'Otključati trošak?',
    unlockConfirm: 'Trošak se vraća u status „U toku” i može se ponovo menjati. Otključavanje se beleži u istoriji.',
    costUnlocked: 'Trošak otključan',
    costLockedNotice: 'Ovaj trošak je zaključen. Samo administrator ga može otključati.',
    progressNotesHint: 'Šta je do sada urađeno — dopunjavajte kako posao napreduje',
    costPerKm: 'Trošak po km',
    byCategory: 'Po kategoriji',
    byVehicle: 'Vozila sa najvećim troškom',
    overTime: 'Kroz vreme',
    noChartData: 'Nema troškova u izabranom periodu',
    addRecurrence: 'Dodaj pravilo',
    addRecurrenceDesc: 'Napravi raspored ponavljajućeg troška',
    editRecurrence: 'Izmeni pravilo',
    editRecurrenceDesc: 'Ažuriraj raspored ponavljajućeg troška',
    ruleType: 'Ponavlja se',
    ruleInterval: 'Svaki period',
    ruleIntervalDesc: 'Godišnja registracija, mesečni lizing',
    ruleMileage: 'Na pređene km',
    ruleMileageDesc: 'Servis ulja svakih 15.000 km',
    ruleIntervalAndMileage: 'Km ili period',
    ruleIntervalAndMileageDesc: 'Šta god prvo nastupi',
    ruleFixedDates: 'Fiksni datumi',
    ruleFixedDatesDesc: 'Letnje i zimske gume',
    intervalValue: 'Svakih',
    intervalUnit: 'Jedinica',
    unitDay: 'Dana',
    unitMonth: 'Meseci',
    unitYear: 'Godina',
    mileageInterval: 'Svakih (km)',
    fixedDates: 'Datumi',
    addFixedDate: 'Dodaj datum',
    anchorDate: 'Počevši od',
    anchorOdometer: 'Početna kilometraža',
    estimatedAmount: 'Procenjeni iznos',
    leadDays: 'Upozori dana ranije',
    leadKm: 'Upozori km ranije',
    ruleActive: 'Aktivno',
    rulePaused: 'Pauzirano',
    nextDue: 'Sledeće dospeće',
    nextDueOdometer: 'Dospeva na',
    noRecurrences: 'Još nema ponavljajućih troškova',
    upcomingTitle: 'Nadolazeći troškovi',
    severityOverdue: 'Kasni',
    severityDueSoon: 'Uskoro dospeva',
    severityUpcoming: 'Predstoji',
    daysLeft: 'dana preostalo',
    daysOverdue: 'dana kašnjenja',
    kmLeft: 'km preostalo',
    kmOverdue: 'km preko',
    logCost: 'Evidentiraj trošak',
    dismiss: 'Odbaci',
    noUpcoming: 'Ništa ne dospeva',
    noUpcomingDesc: 'Nema troškova koji dospevaju u ovom periodu',
    history: 'Istorija promena',
    historyDesc: 'Ko je kreirao i menjao ovaj trošak',
    noHistory: 'Još nema istorije',
    deletedDesc: 'Troškovi obrisani u odabranom periodu i ko ih je obrisao. Period se odnosi na vreme brisanja. Dugme istorije otvara celu istoriju troška.',
    deletedAt: 'Obrisano',
    deletedBy: 'Obrisao korisnik',
    deletedByOn: 'Obrisao korisnik {user}, {time}',
    deletedUnavailable: 'Pregled obrisanih troškova još nije dostupan na serveru. Istorija svakog troška se i dalje čuva.',
    deletedRangeTooLong: 'Odaberite period od najviše 366 dana.',
    logCreate: 'kreirao',
    logUpdate: 'izmenio',
    logDelete: 'obrisao',
    logGenerate: 'automatski generisano',
    logComplete: 'označio kao realizovan',
    systemUser: 'Sistem',
    notSet: 'nije postavljeno',
    tabDetails: 'Detalji',
    logTime: 'Vreme',
    logUser: 'Korisnik',
    logAction: 'Akcija',
    logChanges: 'Izmene',
    logField: 'Polje',
    logBefore: 'Pre',
    logAfter: 'Posle',
    logNoChanges: 'Za ovaj unos nisu zabeležene izmene polja',
    attachments: 'Fajlovi',
    attachmentsDesc: 'Računi, fakture i fotografije za ovaj trošak',
    attachmentsQueuedDesc: 'Fajlovi se otpremaju kada se trošak sačuva',
    addFile: 'Dodaj fajl',
    noAttachments: 'Nema priloženih fajlova',
    attachmentLimit: 'Trošak može imati najviše {count} fajlova',
    uploading: 'Otpremanje…',
    uploadFailed: 'Otpremanje nije uspelo',
    retry: 'Pokušaj ponovo',
    remove: 'Ukloni',
    openAttachment: 'Otvori fajl',
    deleteAttachment: 'Obriši fajl',
    deleteAttachmentConfirm: 'Obrisati „{name}“? Ovo se ne može poništiti.',
    attachmentDeleted: 'Fajl je obrisan',
    deleteCostTitle: 'Obrisati trošak?',
    deleteCostConfirm: 'Trošak prelazi na tab Obrisani, odakle se može vratiti.',
    deleteCostWithFiles: 'Trošak i njegovi priloženi fajlovi ({count}) prelaze na tab Obrisani. Ako se vrati u roku od {days} dana, vraćaju se i fajlovi. Nakon toga fajlovi se trajno brišu.',
    logAttachmentAdd: 'je dodao/la',
    logAttachmentDelete: 'je uklonio/la',
    logClose: 'je zaključio/la',
    logUnlock: 'je otključao/la',
    logRestore: 'vraćen',
    attachmentUnsupportedType: '„{name}“ nije podržan tip fajla (JPG, PNG, WebP, HEIC ili PDF)',
    attachmentTooLarge: '„{name}“ je veći od 20 MB',
    attachmentEmpty: '„{name}“ je prazan',
    attachmentsFailed: 'Trošak je sačuvan, ali {count} fajl(ova) nije otpremljeno. Dodajte ih ponovo iz troška.',
    attachmentCountLabel: 'Priloženih fajlova: {count}',
    createdBy: 'Kreirao',
    updatedBy: 'Poslednji put izmenio',
    costAdded: 'Trošak je uspešno dodat',
    costUpdated: 'Trošak je uspešno izmenjen',
    costDeleted: 'Trošak je uspešno obrisan',
    costRestored: 'Trošak je vraćen',
    restoreCost: 'Vrati',
    restoreCostTitle: 'Vratiti ovaj trošak?',
    restoreCostConfirm: '„{title}“ se vraća kakav je bio pre brisanja, zajedno sa istorijom.',
    restoreFilesKept: 'Priloženi fajlovi, ako ih je imao, vraćaju se sa njim.',
    restoreFilesPurged: 'Obrisan je pre više od {days} dana, pa su priloženi fajlovi, ako ih je imao, trajno obrisani i neće se vratiti.',
    recurrenceAdded: 'Pravilo je uspešno dodato',
    recurrenceUpdated: 'Pravilo je uspešno izmenjeno',
    recurrenceDeleted: 'Pravilo je uspešno obrisano',
    noCosts: 'Nema evidentiranih troškova',
    reportTitle: 'Izveštaj o troškovima',
    reportSubtitle: 'Troškovi vozila za izabrani period',
  },

  // Activity log
  activityPage: {
    title: 'Dnevnik aktivnosti',
    subtitle: 'Šta je svaki korisnik otvarao, preuzimao i menjao',
    user: 'Korisnik',
    allUsers: 'Svi korisnici',
    eventType: 'Radnja',
    allEventTypes: 'Sve radnje',
    resource: 'Oblast',
    allResources: 'Sve oblasti',
    searchPlaceholder: 'Pretraga aktivnosti',
    eventLogin: 'Prijava',
    eventLogout: 'Odjava',
    eventPageView: 'Otvorena stranica',
    eventReportGenerate: 'Generisan izveštaj',
    eventHistoryQuery: 'Pretraga istorije',
    eventExportPdf: 'Izvoz u PDF',
    eventExportExcel: 'Izvoz u Excel',
    eventExportMapPdf: 'Izvoz mape u PDF',
    eventCreate: 'Kreirano',
    eventUpdate: 'Izmenjeno',
    eventDelete: 'Obrisano',
    resourceSession: 'Sesija',
    resourcePage: 'Stranica',
    resourceReport: 'Izveštaj',
    resourceHistory: 'Istorija',
    resourceVehicle: 'Vozilo',
    resourceDriver: 'Vozač',
    resourceZone: 'Zona',
    resourcePoi: 'Tačka interesa',
    resourceGroup: 'Grupa',
    resourceUser: 'Korisnik',
    resourceCost: 'Trošak',
    resourceCostCategory: 'Kategorija troška',
    resourceCostRecurrence: 'Ponavljajući trošak',
    resourceScheduledReport: 'Zakazani izveštaj',
    summaryTitle: 'Korisnici',
    summarySubtitle: 'Poslednja prijava i aktivnost u izabranom periodu',
    lastLogin: 'Poslednja prijava',
    lastActivity: 'Poslednja aktivnost',
    logins: 'Prijava',
    events: 'Događaja',
    neverLoggedIn: 'Nikada se nije prijavio',
    time: 'Vreme',
    action: 'Radnja',
    area: 'Oblast',
    details: 'Detalji',
    path: 'Stranica',
    ipAddress: 'IP adresa',
    noActivity: 'Nema zabeležene aktivnosti',
    moreAvailable: 'Prikazani su samo najnoviji redovi — suzite vremenski period da biste videli stariju aktivnost.',
    notAuthorized: 'Samo za administratore',
    notAuthorizedDesc: 'Dnevnik aktivnosti je dostupan administratorima naloga.',
    reportTitle: 'Izveštaj o aktivnosti',
    reportSubtitle: 'Aktivnost korisnika za izabrani period',
  },

  scheduledReportsPage: {
    title: 'Zakazani izveštaji',
    subtitle: 'Izveštaji koji vam automatski stižu emailom, po rasporedu',
    newSchedule: 'Novi raspored',
    editSchedule: 'Izmena rasporeda',
    empty: 'Još nema zakazanih izveštaja',
    emptyDesc: 'Napravite raspored da biste izveštaj dobijali svaki dan, nedelju ili mesec.',
    unavailable: 'Zakazani izveštaji još nisu dostupni',
    unavailableDesc: 'Server još ne podržava zakazane izveštaje. Pokušajte kasnije.',
    name: 'Naziv',
    namePlaceholder: 'npr. Jučerašnja putovanja',
    reportType: 'Izveštaj',
    group: 'Grupa',
    vehicle: 'Vozilo',
    frequency: 'Učestalost',
    daily: 'Dnevno',
    weekly: 'Nedeljno',
    monthly: 'Mesečno',
    sendTime: 'Vreme slanja',
    weekdays: 'Dani slanja',
    weekdaysHint: 'Ako nijedan dan nije izabran, šalje se svaki dan.',
    weekday: 'Dan u nedelji',
    monthDay: 'Dan u mesecu',
    timeZone: 'Vremenska zona',
    searchTimeZone: 'Pretraži vremenske zone...',
    noTimeZones: 'Nema pronađenih vremenskih zona',
    language: 'Jezik emaila',
    formats: 'Prilozi',
    formatPdf: 'PDF',
    formatXlsx: 'Excel',
    recipients: 'Primaoci',
    recipientsPlaceholder: 'ime@primer.com',
    recipientsHint: 'Pritisnite Enter ili zarez da dodate adresu. Najviše 10.',
    removeRecipient: 'Ukloni {email}',
    active: 'Aktivan',
    schedule: 'Raspored',
    nextRun: 'Sledeće slanje',
    lastRun: 'Poslednje slanje',
    never: 'Nikad',
    statusOk: 'Poslato',
    statusFailed: 'Neuspešno',
    statusRetrying: 'Ponovni pokušaj',
    periodDaily: 'Svaki email obuhvata prethodni dan.',
    periodWeekly: 'Svaki email obuhvata prethodnu nedelju, od ponedeljka do nedelje.',
    periodMonthly: 'Svaki email obuhvata prethodni kalendarski mesec.',
    summaryDaily: 'Svaki dan u {time}',
    summaryDailyDays: '{days} u {time}',
    summaryWeekly: 'Svaki {day} u {time}',
    summaryMonthly: 'Mesečno, {day}. u mesecu u {time}',
    nextSendPreview: 'Sledeće slanje: {date}',
    sendNow: 'Pošalji sada',
    sendNowQueued: 'Izveštaj je u redu za slanje i trebalo bi da stigne za nekoliko minuta.',
    runHistory: 'Istorija slanja',
    noRuns: 'Ovaj raspored još ništa nije poslao.',
    runTime: 'Vreme',
    runStatus: 'Status',
    runRows: 'Zapisi',
    runRecipients: 'Primaoci',
    runError: 'Greška',
    runTrigger: 'Pokretanje',
    triggerSchedule: 'Po rasporedu',
    triggerManual: 'Ručno',
    deleteTitle: 'Obrisati zakazani izveštaj?',
    deleteDescription: '"{name}" više neće biti slat i biće trajno obrisan.',
    created: 'Zakazani izveštaj je kreiran',
    updated: 'Zakazani izveštaj je izmenjen',
    deleted: 'Zakazani izveštaj je obrisan',
    activated: 'Raspored je uključen',
    deactivated: 'Raspored je isključen',
    scheduleThisReport: 'Zakaži',
    nameRequired: 'Unesite naziv',
    formatRequired: 'Izaberite bar jedan prilog',
    recipientsRequired: 'Dodajte bar jednog primaoca',
    weekdayRequired: 'Izaberite dan u nedelji',
    invalidTime: 'Unesite vreme u formatu HH:MM',
    actions: 'Akcije',
  },

  scheduledReportEmail: {
    subject: '{report}: {period}',
    intro: 'U prilogu je vaš zakazani izveštaj "{name}".',
    report: 'Izveštaj',
    period: 'Period',
    scope: 'Vozila',
    records: 'Zapisi',
    noData: 'U ovom periodu nije zabeležena nikakva aktivnost.',
    footer: 'Ovaj email je automatski poslao {app}. Da ga izmenite ili zaustavite, otvorite Podešavanja → Zakazani izveštaji.',
  },

  // Toasts
  toast: {
    welcomeBack: 'Dobrodošli nazad!',
  },
};
